// src/App.tsx
import React from "react";
import Game from "./components/Game";

const App: React.FC = () => {
  return (
    <div className="App">
      <Game />
    </div>
  );
};

export default App;
